import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';
import { useProductFeatures } from 'bundles/enterprise-admin/features';
import { IdTypes } from 'bundles/product-features';

export const useEnableLearnerGroups = (organizationId?: string): boolean => {
  const thirdPartyOrganization = useThirdPartyOrganization();
  const id = organizationId ?? thirdPartyOrganization?.id ?? '';
  const { features } = useProductFeatures({
    idType: IdTypes.Organization,
    id,
    skip: !id,
  });
  return features.get('enterprise', 'enableLearnerGroups');
};

type EnableLearnerGroupsStatus = {
  enabled: boolean;
  loading: boolean;
};

/**
 * Reads the same flag as `useEnableLearnerGroups`, but also reports whether the feature query is
 * still in flight.
 *
 * The boolean hook returns `false` while loading, which is the right default for rendering decisions
 * but not for navigation ones: a caller that redirects on the flag would render the page it is meant
 * to redirect away from before the flag resolves. Use this hook when the `false` and the
 * not-yet-known cases have to be told apart; prefer `useEnableLearnerGroups` otherwise.
 */
export const useEnableLearnerGroupsStatus = (organizationId?: string): EnableLearnerGroupsStatus => {
  const thirdPartyOrganization = useThirdPartyOrganization();
  const id = organizationId ?? thirdPartyOrganization?.id ?? '';
  const { features, loading } = useProductFeatures({
    idType: IdTypes.Organization,
    id,
    skip: !id,
  });

  return { enabled: features.get('enterprise', 'enableLearnerGroups'), loading };
};
